import { render, staticRenderFns } from "./coureDetail.vue?vue&type=template&id=5506a09d&"
import script from "./coureDetail.vue?vue&type=script&lang=js&"
export * from "./coureDetail.vue?vue&type=script&lang=js&"
import style0 from "./coureDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports